import Vue from "vue";
import Vuex from "vuex";
import appsModule from "./apps";
import bannersModule from "./banners";
import appModule from "./singleApp";
import interestedPersonModule from "./interestedPerson";
import regionModule from "./regions";
import infoRequestModule from "./infoRequest";
import salesRepsModule from "./salesReps";
import currentUserModule from "./currentUser";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    apps: {
      namespaced: true,
      ...appsModule,
    },
    banners: {
      namespaced: true,
      ...bannersModule,
    },
    singleApp: {
      namespaced: true,
      ...appModule,
    },
    interestedPerson: {
      namespaced: true,
      ...interestedPersonModule,
    },
    regions: {
      namespaced: true,
      ...regionModule,
    },
    infoRequest: {
      namespaced: true,
      ...infoRequestModule,
    },
    salesReps: {
      namespaced: true,
      ...salesRepsModule,
    },
    currentUser: {
      namespaced: true,
      ...currentUserModule,
    },
  },
});
